export enum ClaimMessages {
  access = "claim.access",
  activateFutureStatus = "claim.activateFutureStatus",
  activateStatus = "claim.activateStatus",
  alter = "claim.alter",
  changeStatus = "claim.changeStatus",
  changeSupply = "claim.changeSupply",
  commercialDefault = "claim.commercialDefault",
  costChangeReminder = "claim.costChangeReminder",
  createCopy = "claim.createCopy",
  delete = "claim.delete",
  export = "claim.export",
  inactivate = "claim.inactivate",
  inactivateStatus = "claim.inactivateStatus",
  include = "claim.include",
  print = "claim.print",
  technicalDataChangeReminder = "claim.technicalDataChangeReminder",
  abramsCurveChangeReminder = "claim.abramsCurveChangeReminder",
  includeLogo = "claim.includeLogo",
  deleteLogo = "claim.deleteLogo",
  download = "claim.download",
  alterExternalId = "claim.alterExternalId",
  changeAllocations = "claim.changeAllocations",
  dispatch = "claim.dispatch",
  reintegrate = "claim.reintegrate",
  cancel = "claim.cancel",
  requestAdjustment = "claim.requestAdjustment",
  approveAdjustment = "claim.approveAdjustment",
  changeLink = "claim.changeLink",
  ignoreLink = "claim.ignoreLink",
  closeInventory = "claim.closeInventory",
  closeProduction = "claim.closeProduction",
  reopenProduction = "claim.reopenProduction",
  alterDelivery = "claim.alterDelivery",
  alterPumping = "claim.alterPumping",
  alterScheduling = "claim.alterScheduling",
  approveDisapprovePendingRequests = "claim.approveDisapprovePendingRequests",
  changeDeliveryRoute = "claim.changeDeliveryRoute",
  reopenInventory = "claim.reopenInventory",
  dispatchPumpingTicket = "claim.dispatchPumpingTicket",
  waterCut = "claim.waterCut",
  sendToAutomation = "claim.sendToAutomation",
  creditLimitWebserviceResendForAnalysis = "claim.creditLimitWebserviceResendForAnalysis",
  alertsPageAccess = "claim.alertsPageAccess",
  clientPrepaidAlter = "claim.clientPrepaidAlter",
  constructionNotFoundAlter = "claim.constructionNotFoundAlter",
  constructionExpiredAlter = "claim.constructionExpiredAlter",
  schedulingWithoutExternalIdAlter = "claim.schedulingWithoutExternalIdAlter",
  supplyNotAuthorizedBySecurityVisitAlter = "claim.supplyNotAuthorizedBySecurityVisitAlter",
  productWithoutQuotationAlter = "claim.productWithoutQuotationAlter",
  productOrRecipeInactiveAlter = "claim.productOrRecipeInactiveAlter",
  clientDelinquentAlter = "claim.clientDelinquentAlter",
  clientExpiredCreditDateAlter = "claim.clientExpiredCreditDateAlter",
  clientWithoutCreditLimitAlter = "claim.clientWithoutCreditLimitAlter",
  waitingCreditLimitAnalysisAlter = "claim.waitingCreditLimitAnalysisAlter",
  plantUnavailableAlter = "claim.plantUnavailableAlter",
  closeScheduling = "claim.closeScheduling",
  reopenScheduling = "claim.reopenScheduling",
  blockReasonCreditLimitValidation = "claim.blockReasonCreditLimitValidation",
  blockReasonCreditLimitAnalysis = "claim.blockReasonCreditLimitAnalysis",
  blockReasonProductGroupRequiresApproval = "claim.blockReasonProductGroupRequiresApproval",
  blockReasonNotSentForAutomation = "claim.blockReasonNotSentForAutomation",
  blockReasonProductRequiresApproval = "claim.blockReasonProductRequiresApproval",
  blockReasonProductTypeRequiresApproval = "claim.blockReasonProductTypeRequiresApproval",
  blockReasonSupplyDeviation = "claim.blockReasonSupplyDeviation",
  blockReasonSupplyGroupDeviation = "claim.blockReasonSupplyGroupDeviation",
  blockReasonMissingAutomationResponse = "claim.blockReasonMissingAutomationResponse",
  blockReasonInsufficientStock = "claim.blockReasonInsufficientStock",
  blockReasonGravelNoLoadReuseParamSet = "claim.blockReasonGravelNoLoadReuseParamSet",
  blockReasonProductGroupNoLoadReuseParamSet = "claim.blockReasonProductGroupNoLoadReuseParamSet",
  blockReasonProductNoLoadReuseParamSet = "claim.blockReasonProductNoLoadReuseParamSet",
  blockReasonProductGroupReuseOutOfParams = "claim.blockReasonProductGroupReuseOutOfParams",
  blockReasonProductReuseOutOfParams = "claim.blockReasonProductReuseOutOfParams",
  blockReasonGravelReuseOutOfParams = "claim.blockReasonGravelReuseOutOfParams",
  blockReasonDivergentVolume = "claim.blockReasonDivergentVolume",
  blockReasonWaitingCreditLimitAnalysis = "claim.blockReasonWaitingCreditLimitAnalysis",
  blockReasonExpiredCreditDate = "claim.blockReasonExpiredCreditDate",
  inconsistencyActualSlump = "claim.inconsistencyActualSlump",
  inconsistencyConcreteMixerSchedules = "claim.inconsistencyConcreteMixerSchedules",
  inconsistencyWaterAddedInConstruction = "claim.inconsistencyWaterAddedInConstruction",
  inconsistencyOdometer = "claim.inconsistencyOdometer",
  inconsistencyHourMeter = "claim.inconsistencyHourMeter",
  inconsistencyPumpScheduleWithoutDeliveryTicketPump = "claim.inconsistencyPumpScheduleWithoutDeliveryTicketPump",
  inconsistencyPumpScheduleMissingM3ToIssueDelivery = "claim.inconsistencyPumpScheduleMissingM3ToIssueDelivery",
  inconsistencyUndeliveredAndUncancelledSchedules = "claim.inconsistencyUndeliveredAndUncancelledSchedules",
  inconsistencyUndeliveredAndUncancelledDeliveries = "claim.inconsistencyUndeliveredAndUncancelledDeliveries",
  inconsistencyUnlinkedWeighings = "claim.inconsistencyUnlinkedWeighings",
  inconsistencySefazStatusFiscalDocumentNotSend = "claim.inconsistencySefazStatusFiscalDocumentNotSend",
  inconsistencySefazStatusFiscalDocumentNoAnswer = "claim.inconsistencySefazStatusFiscalDocumentNoAnswer",
  inconsistencySefazStatusFiscalDocumentWithRejection = "claim.inconsistencySefazStatusFiscalDocumentWithRejection",
  inconsistencyAdditionalModifications = "claim.inconsistencyAdditionalModifications",
  inconsistencyLoadTicketWithoutDeliveryTicket = "claim.inconsistencyLoadTicketWithoutDeliveryTicket",
  inconsistencyLoadReuseWithoutDestination = "claim.inconsistencyLoadReuseWithoutDestination",
  manualEntry = "claim.manualEntry",
  viewReports = "claim.viewReports",
  registerExecution = "claim.registerExecution",
  updateExecution = "claim.updateExecution",
  deleteExecution = "claim.deleteExecution",
  completeTask = "claim.completeTask",
  addNotes = "claim.addNotes",
  viewPlantStatus = "claim.viewPlantStatus",
  viewProduction = "claim.viewProduction",
  viewAlarms = "claim.viewAlarms",
  manualCommand = "claim.manualCommand",
  adjustOrders = "claim.adjustOrders",
  acknowledgeAlarm = "claim.acknowledgeAlarm",
  authorizePrivileged = "claim.authorizePrivileged",
  manageLocalUsers = "claim.manageLocalUsers",
  viewAudit = "claim.viewAudit",
  plantDefinition = "claim.plantDefinition",
  alterApplicationOfOwnLabor = "claim.alterApplicationOfOwnLabor",
  adjustedStrength = "claim.adjustedStrength",
  excludeRuptureFromStatistics = "claim.excludeRuptureFromStatistics",
  alterProductWeighted = "claim.alterProductWeighted"
}

export type TranslationClaimMessages = {
  [key in ClaimMessages]: string;
}
